import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { fluidType } from 'Shared/common/FluidType';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { WorkSans } from 'Shared/frontend/fonts/WorkSans';
import { BodoniModa } from 'Shared/frontend/fonts/BodoniModa';
import { Sora } from 'Shared/frontend/fonts/Sora';
import { INav } from 'Common/config/INav';
import {PeopleCircle} from 'Shared/frontend/icons/PeopleCircle'; 
import {PeopleCircle as BackendPeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';




export class TheDrummerSettings extends BaseSettings
{
	palette()
	{
		return{
			background: '#fffef8',
			text: 'black',
			feature: '#eb6019', //keeping site clean
			feature2: '#eb6019', //orange
			inverseText: 'white',

		
			dimBackground: 'white',

			food: '', 
			drinks: '',
		
		};
	}

	fontIncludes()
	{
		return [
			WorkSans,
			BodoniModa,
			Sora,
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Sora", sans-serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,18),	
			fontWeight: '300',	
			
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Sora", sans-serif',
			color: this.palette().text,
			fontWeight: '300',
			lineHeight: 1.5,
		})
	}

	fontsHeading2()
	{
		return({
			fontFamily: '"Bodoni Moda", serif',
			letterSpacing: 1,
			color: this.palette().feature,	
			lineHeight: 1.1,
			fontWeight: '300',
		})
	}

	fonts()
	{
		return {
			text: '"Sora", sans-serif',
			heading:  '"Sora", serif',
			subNav:  '"Sora", serif',
			buttons:  '"Sora", serif',
			desktopNav:  '"Sora", serif',
			mobileNav:  '"Sora", serif',
		};
	}

	
	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.5em 0',
		})
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,70),
		
			},
			title: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,50),
			},
			plain: {
			...this.fontsText(),
				
			},

			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),
			},
			tagline: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,20),	
				
			},

			subtitle: {
				...this.fontsHeading2(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,30),
    	
			},
		});
	}


	//TODO BEN these might also work as a 'style' so users can select the button type they want
	button()
	{
		return({
			hollow: {
				button: {
					color: this.palette().text,
					border: 'solid',
					borderColor: this.palette().text,
					borderWidth: 0.5,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					textTransform: 'uppercase',
					backgroundColor: this.palette().background
				},
				
			},
			filled: {
				button: {
					backgroundColor: this.palette().feature,
					color: this.palette().background,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					borderRadius: '0.4em',
				},
			}
		})
	}
	

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().dimBackground,
					...this.fontsHeading(),
					lineHeight: 1.1,
					color: this.palette().feature,
					border: '.5px solid #dfd8d0',
					
				},
				dateBar: {
					backgroundColor: this.palette().dimBackground,
					...this.fontsHeading(),
					fontSize: '14px',
					color: this.palette().feature,
					
				},
			
			},
			themes:{
				overlapping:{
					tagline: {
						...this.fontsText(),
						fontStyle: 'normal',	
					},
				},
			},
		});
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			...this.button().hollow,

			widgets: {
				scrollStyle:{
					scrollbarColor: '#ffffff #ffffff !important', //#sliderColor #outerColor
				},

                grid: {
					columnGap: 0,
					rowGap: 0,
				},
                
				overlay: {

					'.text-teaser':{
						fontWeight: '700',
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,32),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,	
					},

					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,36),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,	
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,26,36),
						color: this.palette().inverseText,	
                        letterSpacing: -2,
					},

					button: {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),
						fontFamily: '"Bodoni Moda", serif',
						background: 'transparent',
						width: '100%',
						padding: 0,
						textDecoration:'underline',
						textTransform: 'initial',
					},

					'.text-plain': {
						fontSize: 16,
						color: this.palette().inverseText,
						a:{
							fontSize: 16,
						
							color: this.palette().inverseText,
						}
					},
				},
				subNav: {
					...this.button().hollow,
				},
			},

		});
	}
//navigation
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',		
				settings: {

					outer: {
						background: this.palette().background,
					},
					button: {
						...this.fontsHeading(),
						color: palette.text,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,10,20),
						':hover': {
							color: palette.text,
						}
					},
					active: {
						color: palette.feature,
					},

					logo: {
						height: '50%',
						padding: '0px 5px 5px 0'
					},
				},
			},

			mobile:{		
				overlay:{background: palette.background},
		
				button:{
					color: palette.text,
					background: palette.background,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.text} !important`
					},

					':hover': {
			//TODO cf remove from BaseTheme?						
		//						color: this.palette().inverseText,
						backgroundColor: this.palette().dimBackground
					}
				},
				active: {
					color: palette.feature,
					svg:{
						fill: `${palette.feature} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.background,

					},
					button: {
						color: this.palette().text,
						':hover': {
							color: this.palette().feature,
							backgroundColor: this.palette().dimBackground,
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();
		
		
		//Defaults to 'General' unless uncommented and altered
		/*base.specials = {
			general: 'General',
			beers: 'Beers'
		};
		*/

// @ts-expect-error		
		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			styles: {

				'Banner Logo': {
					rules: () => [{
						location: ['*'],
						css: { 
							paddingLeft: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,300),
							paddingRight: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,300),
							height: '60vh',
						},
					}]
				},

			},

			home: {
				nav: {
					desktop: {
						type: 'none',
					},
				},
			},

			event: {
				subNav: {
					...this.button().hollow
				},

				heading: {
					...this.fontsHeading(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					...this.button().hollow,
				},
				section: {
					marginBottom: '3em',
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					},
				},
				
			},

			contact: {
				showReservationButton: true
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}


	pages()
	{
		return [
			
			{
				key: 'reserve',
				frontend: {
					route: '/reservation',
					metaTitle: 'Reserve'
				},
				backend: {
					tab: 'Reservations',
					title: 'Reserve'
				}
			},
			
			
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Reserve',	link:'frontend/Reservation'},
				{label:'Contact',	link:'frontend/Contact'},

			],
			mobile: {
				maxButtons: 6,
				includeMoreButton: true,
				
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Reserve',	link:'frontend/Reservation', 	icon:PeopleCircle},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:BackendPeopleCircle},
		];
	}

}

